// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'
import commonJs from './public/common'
import saasApi from './public/saasApi'
// 语言转换
import '../static/common-css/common.css'
import '../static/font/iconfont.css'
import '../static/font/iconfont'
import $ from 'jquery';
// import 'signalr'
import i18n from './i18n/i18n';
// 引用API文件
import filters from './public/filters';//过滤器
// import api from './public/ajax.js'
import api from './public/oidcRoot.js'
import axios from 'axios';
Vue.prototype.$ajax = axios
// 将API方法绑定到全局
Vue.prototype.$http = api.utils;      //axios请求设置
Vue.prototype.commonJs = commonJs;      //公共方法申明
Vue.prototype.saasApi = saasApi;      //公共接口方法
// Vue.prototype.progressTime = null;      //定时器

Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  filters,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js